import styled from 'styled-components';
import {
  openDetailLink,
  openKakaoLink,
  openYoutubeLink,
  openAppDownloadLink,
  isPc,
} from '../../utils';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

const links = [
  {
    icon: ImageUtils.SnsIcon1,
    text: '피망 쇼다운\n 앱 다운로드',
    onClick: openAppDownloadLink,
    onlyWeb: true,
  },
  {
    icon: ImageUtils.SnsIcon2,
    text: 'PFGT\n카카오톡 채널',
    onClick: openKakaoLink,
  },
  {
    icon: ImageUtils.SnsIcon3,
    text: '피망 포커스\n유튜브',
    onClick: openYoutubeLink,
  },
  {
    icon: ImageUtils.SnsIcon4,
    text: '대회\n상세 안내',
    onClick: openDetailLink,
  },
];

export const BottomSns = () => {
  const pc = isPc();

  return (
    <Container>
      {links.map((link, index) => {
        if (!pc && link.onlyWeb) {
          return null;
        }
        return (
          <Link key={index} onClick={link.onClick}>
            <img src={link.icon} alt="" />
            <LinkText>
              {link.text.split('\n').map((line, i) => (
                <span key={i + 'sns'}>
                  {line}
                  {i < link.text.split('\n').length - 1 && <Br />}
                </span>
              ))}
            </LinkText>
          </Link>
        );
      })}
    </Container>
  );
};

const Br = styled.br`
  display: none;
  ${mobileQuery} {
    display: block;
  }
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  max-width: 1000px;
  width: 100%;
  z-index: 10;
  height: 125px;

  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  background: rgba(64, 64, 64, 0.5);

  border-top-right-radius: 60px;
  border-top-left-radius: 60px;

  display: flex;
  ${mobileQuery} {
    height: 79px;

    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
  }
`;

const Link = styled.div`
  height: 100%;
  flex: 1;
  text-align: center;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 24px;

  &:last-child {
    border-right: none;
  }

  ${mobileQuery} {
    padding-bottom: 10px;
  }

  img {
    margin-bottom: 11px;
  }

  ${mobileQuery} {
    img {
      width: 21px;
      margin-bottom: 5px;
    }
  }
`;

const LinkText = styled.h4`
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.88px;

  color: rgba(255, 255, 255, 0.8);

  ${mobileQuery} {
    font-size: 12px;
    line-height: 15px;
  }
`;
